import Seo from "../components/Seo";


function ImpressumPage() {

    return (

        <>

            <Seo
                title="Impressum"
                description="Impressum und Kontaktangaben der persönlichen Webseite von Ivan Jörg."
                canonical="https://www.irj.ch/impressum"
            />


            <div className="intro">

                <p>
                    Impressum und Kontakt bezüglich Webseite:
                </p>

            </div>


            <main>

                <h1>
                    Impressum
                </h1>


                <p>

                    <strong>
                        Betreiber:
                    </strong>

                    <br />

                    Ivan Jörg

                    <br />

                    Grossfeldstrasse 2

                    <br />

                    8887 Mels SG

                    <br />
                    <br />


                    <strong>
                        Kontakt:
                    </strong>

                    <br />

                    Mail:{" "}

                    <a href="mailto:ivan@irj.ch">
                        ivan@irj.ch
                    </a>

                </p>

            </main>

        </>

    );
}


export default ImpressumPage;